import PeopleIcon from '@mui/icons-material/People';
import { Badge, Box, Button, IconButton } from "@mui/material";
import CloudOffIcon from '@mui/icons-material/CloudOff';
import CloudOffTwoToneIcon from '@mui/icons-material/CloudOffTwoTone';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import CloseIcon from '@mui/icons-material/Close';
import LogoutIcon from '@mui/icons-material/Logout';
import ListAltIcon from '@mui/icons-material/ListAlt';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

import { auth } from "./firebase.js";
import { signOut } from "firebase/auth";

function Header(props) {
    const { View, User, isConnected, pendingCount, checkedRows, newFamilyGroupId, setShowNewDebitDialog, debitsGeneration, AddMembersToFamilyGroup, clearUploadCache, manuallyDiconnected, setManuallyDisconnected } = props;

    return (
        <header style={{ width: '100%', position: 'sticky', top: 0, zIndex: 100 }}>
            {User.uid ?
                <Box sx={{ width: '100%', padding: '1em 2em', display: 'flex', alignItems: 'center', gap: '.5em', justifyContent: 'space-between', flexDirection: { xs: 'column', sm: 'row' }, backgroundColor: 'black', color: 'white' }}>
                    <Button
                        sx={{ p: 0, fontSize: 20, fontWeight: 'bold', textTransform: 'none', color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}
                        onClick={() => window.location.hash = ''}
                    >
                        Alta Gracia Rugby
                        <img style={{ height: '1.5em' }} src="/logo.png" alt="logo" />
                    </Button>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '.5em' }}>

                        {(View === 'members' && checkedRows) ?
                            <Button
                                variant="contained"
                                color="secondary"
                                startIcon={<RequestQuoteIcon />}
                                sx={{
                                    textTransform: 'none',
                                    fontSize: { xs: 0, sm: '.9em' },
                                    '& .MuiButton-icon': { margin: { xs: 0, sm: '0 8px 0 -4px' } }
                                }}
                                onClick={() => setShowNewDebitDialog(true)}
                            >
                                Nuevo Débito
                            </Button>
                            : ''}

                        {(View === 'members' && checkedRows) || View === 'member' ?
                            <Button
                                variant="contained"
                                color="secondary"
                                startIcon={<DynamicFeedIcon />}
                                sx={{
                                    textTransform: 'none',
                                    fontSize: { xs: 0, sm: '.9em' },
                                    '& .MuiButton-icon': { margin: { xs: 0, sm: '0 8px 0 -4px' } }
                                }}
                                onClick={debitsGeneration}
                            >
                                Generar Cuotas
                            </Button>
                            : ''}

                        {(View === 'members' && checkedRows) ?
                            <Button
                                variant="contained"
                                color="secondary"
                                startIcon={<PeopleIcon />}
                                sx={{
                                    textTransform: 'none',
                                    opacity: !newFamilyGroupId ? .25 : 1,
                                    fontSize: { xs: 0, sm: '.9em' },
                                    '& .MuiButton-icon': { margin: { xs: 0, sm: '0 8px 0 -4px' } }
                                }}
                                onClick={AddMembersToFamilyGroup}
                            >
                                Nuevo Grupo Familiar
                            </Button>
                            : ''}

                        {View === 'members' && !checkedRows ?
                            <IconButton
                                aria-label={`new member`}
                                color="secondary"
                                onClick={() => window.location.hash = `socio?nuevo`}
                            >
                                <PersonAddIcon />
                            </IconButton>
                            : ''}

                        {View === 'members' && !checkedRows ?
                            <IconButton
                                aria-label={`otugoings`}
                                color="secondary"
                                onClick={() => window.location.hash = `gastos`}
                            >
                                <ReceiptLongIcon />
                            </IconButton>
                            : ''}

                        {View === 'members' && !checkedRows ?
                            <IconButton
                                aria-label={`admin menu`}
                                color="secondary"
                                onClick={() => window.location.hash = `admin`}
                            >
                                <ListAltIcon />
                            </IconButton>
                            : ''}

                        {
                            View !== 'members' || !checkedRows ?
                                !isConnected ?
                                    <IconButton
                                        aria-label={`${pendingCount} offline changes`}
                                        color="secondary"
                                        title={`${pendingCount} Cambios pendientes de cargar`}
                                        onDoubleClick={clearUploadCache}
                                        onClick={() => setManuallyDisconnected(p => ({ s: !p.s, o: 'user' }))}
                                    >
                                        <Badge badgeContent={pendingCount} >
                                            {manuallyDiconnected.s ?
                                                <CloudOffTwoToneIcon sx={{ color: 'limegreen' }} /> :
                                                <CloudOffIcon />}
                                        </Badge>
                                    </IconButton>
                                    :
                                    <IconButton
                                        aria-label={`${pendingCount} offline changes`}
                                        color="secondary"
                                        title={pendingCount > 0 ? `${pendingCount} Cambios pendientes de cargar` : ''}
                                        onClick={() => setManuallyDisconnected(p => ({ s: !p.s, o: 'user' }))}
                                    >
                                        {pendingCount > 0 ?
                                            <Badge badgeContent={pendingCount} max={99999}>
                                                <CloudUploadIcon />
                                            </Badge>
                                            :
                                            <CloudDoneIcon sx={{ opacity: .5 }} />
                                        }
                                    </IconButton>
                                : ''
                        }

                        {View === 'members' && !checkedRows ?
                            <IconButton
                                aria-label={`log out`}
                                color="secondary"
                                onClick={() => signOut(auth).then(() => window.location.reload()).catch(console.error)}
                            >
                                <LogoutIcon />
                            </IconButton>
                            : ''}

                        {View !== 'members' ?
                            <IconButton
                                aria-label={`close`}
                                color="primary"
                                onClick={() => window.location.hash = ``}
                            >
                                <CloseIcon />
                            </IconButton>
                            : ''}

                    </Box>
                </Box> : ''}
        </header>
    );
}

export default Header;
